import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Cancel from "./../assets/assets/delete.svg";
import { useSelector } from "react-redux";
import View from "./../assets/assets/view-icon.svg";
import DownloadIcon from "./../assets/assets/download.svg";
import UserModal from "../components/EmailModal/UserModal";
import { uploadFile } from "./cloudinary";
import { callUrlFunction } from "./callUrlFunction";
import File from "./../assets/assets/file.svg";

// Shared helper
function buildDerivedUrls(url) {
  const isPdf = !!url && /\.pdf($|\?)/i.test(url);

  if (!url) {
    return { fileResult: "", filePreview: "", fileEmbed: "", fileDownload: "", fileType: "" };
  }

  if (!isPdf) {
    return { fileResult: url, filePreview: url, fileEmbed: url, fileDownload: url, fileType: "image" };
  }

  return {
    fileResult: url,
    fileEmbed: url.replace("/raw/upload/", "/raw/upload/fl_inline/"),
    fileDownload: url.replace("/raw/upload/", "/raw/upload/fl_attachment/"),
    filePreview: url.replace("/raw/upload/", "/image/upload/pg_1,w_300/").replace(/\.pdf($|\?)/i, ".jpg$1"),
    fileType: "pdf",
  };
}

const UploadWidget = ({ title, handleDataFetch, handleRemoval, id, url, error }) => {
  const derived = buildDerivedUrls(url);

  const [state, setState] = useState({
    loaded: !!url,
    fileResult: derived.fileResult,
    filePreview: derived.filePreview,
    fileEmbed: derived.fileEmbed,
    fileDownload: derived.fileDownload,
    file_name: "",
    file_type: derived.fileType,
    showModal: false,
    previewBroken: false,
  });

  const success = useSelector((s) => s.singleUser.uploadSuccess);

  useEffect(() => {
    if (success) {
      setState({
        loaded: false,
        fileResult: "",
        filePreview: "",
        fileEmbed: "",
        fileDownload: "",
        file_name: "",
        file_type: "",
        showModal: false,
        previewBroken: false,
      });
    }
    // eslint-disable-next-line
  }, [success]);

  const showWidget = async () => {
    try {
      await uploadFile(callUrlFunction(handleDataFetch, id, setState, state));
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  const removeFile = () => {
    handleRemoval({ id, url: state.fileResult });
    setState({
      ...state,
      fileResult: "",
      filePreview: "",
      fileEmbed: "",
      fileDownload: "",
      file_name: "",
      file_type: "",
      loaded: false,
      previewBroken: false,
    });
  };

  const viewDoc = () => setState((s) => ({ ...s, showModal: true }));
  const closeDoc = () => setState((s) => ({ ...s, showModal: false }));

  const shortenName = (str) => (str?.length > 12 ? str.slice(0, 12) + "..." : str);

  return (
    <div className="upload-file">
      {state.loaded && (
        <div className="view-doc-upload">
          <div className="view-doc-upload-image" onClick={viewDoc}><img src={View} alt="view" /></div>
          <span onClick={viewDoc} data-testid="viewDoc">View</span>
          <div className="view-doc-upload-image" style={{ marginLeft: "1rem" }}>
            <a href={state.fileDownload || state.fileResult} download={state.file_name}>
              <img src={DownloadIcon} alt="download" />
            </a>
          </div>
          <span><a href={state.fileDownload || state.fileResult} download={state.file_name}>Download</a></span>
        </div>
      )}

      <h3>{title}</h3>

      <UserModal open={state.showModal} close={closeDoc} height="739" width="1000">
        <div style={{ padding: "20px" }}>
          <span className="iframe-back2" onClick={closeDoc} data-testid="closeDoc">X</span>
          {state.file_type === "pdf" ? (
            <>
              {!state.previewBroken && state.filePreview ? (
                <img
                  src={state.filePreview}
                  alt="PDF Preview"
                  style={{ width: "220px", marginBottom: "10px", border: "1px solid #eee" }}
                  onError={() => setState((s) => ({ ...s, previewBroken: true }))}
                />
              ) : (
                <div style={{ width: 220, height: 310, marginBottom: 10, border: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span>Preview unavailable</span>
                </div>
              )}
              <embed src={state.fileEmbed || state.fileResult} width="100%" height="1000" title={title} type="application/pdf" />
              <div style={{ marginTop: 8 }}>
                <a href={state.fileResult} target="_blank" rel="noopener noreferrer">Open in new tab</a>
              </div>
            </>
          ) : (
            <img src={state.fileResult} alt={title} style={{ width: "100%", maxHeight: "1000px", objectFit: "contain" }} />
          )}
        </div>
      </UserModal>

      {!state.loaded ? (
        <div>
          <button data-testid="showWidget" onClick={showWidget}>+ &nbsp; &nbsp; CHOOSE FILE</button>
          {error && <span style={{ color: "red" }}>{error}</span>}
        </div>
      ) : (
        <div className="uploaded-file-doc">
          <span><img src={File} alt="file" /> &nbsp; {shortenName(state.file_name)}</span>
          <div className="icon-upload" onClick={removeFile} data-testid="removeFile">
            <img src={Cancel} alt="remove" />
          </div>
        </div>
      )}
    </div>
  );
};

UploadWidget.propTypes = {
  error: PropTypes.string,
  handleDataFetch: PropTypes.func,
  handleRemoval: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  url: PropTypes.string,
};

export default UploadWidget;
